<template>
  <v-input>
    <template #default>
      <v-row justify="space-between">
        <v-col md="6" class="maxHeight"> <slot name="start" /> </v-col>
        <v-col md="6" class="maxHeight"> <slot name="end" /> </v-col>
      </v-row>
    </template>
  </v-input>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" scoped>
.maxHeight {
  max-height: 66px;
}
</style>
